
import Vue from 'vue'
import Swal from 'sweetalert2'

interface Data {
  privateKey: PrivateKey | null
  protobuf: string | null,
  avatarURL: string
}

export default Vue.extend({
  data: (): Data => ({
    privateKey: null,
    protobuf: null,
    avatarURL: ''
  }),

  created() {
    this.run()
  },

  methods: {
    async run() {
      try {
        this.privateKey = await this.$accessor.ipfs.resetIdentity()
        this.protobuf = this.privateKey.toProtobuf()
        this.avatarURL = await this.$accessor.ipfs.fetchAvatarURL(this.privateKey.peerId)
      } catch (err: any) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message
        })
      }
    },

    reload() {
      location.reload()
    }
  }
})
